import { FinanceValueObjectsJournalDraftEntryStatusEnum } from 'generated/resources/graphql'

import useFilters from 'modules/core/components/DataTable/hooks/useFilters'
import i18n from 'modules/core/lib/i18n'

import { buildAccountingDraftEntriesCountWidget } from 'modules/finance/components/Widgets/AccountingDraftEntriesCountWidget'
import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'

const DraftEntryStatuses: Record<
  'draft' | 'readyToPublish' | 'unbalanced',
  FinanceValueObjectsJournalDraftEntryStatusEnum[]
> = {
  draft: ['draft'],
  readyToPublish: ['ready_to_publish'],
  unbalanced: ['unbalanced'],
}

interface JornalsDraftEntryInsightsProps {
  companyId: number
}

export const Insights = ({ companyId }: JornalsDraftEntryInsightsProps) => {
  const { getFiltersVariables } = useFilters()
  const dataTableFilters = getFiltersVariables().filter ?? {}

  const widgetConfigs = [
    {
      title: i18n.t('finance.overview.accounting.pending_publish'),
      statuses: [],
    },
    {
      title: i18n.t('finance.journal_entry.data.status.ready_to_publish'),
      statuses: DraftEntryStatuses.readyToPublish,
    },
    {
      title: i18n.t('finance.journal_entry.data.status.unbalanced'),
      statuses: DraftEntryStatuses.unbalanced,
    },
    {
      title: i18n.t('finance.journal_entry.data.status.draft'),
      statuses: DraftEntryStatuses.draft,
    },
  ]

  return (
    <DataTableWidgetInsights
      useBox
      widgets={widgetConfigs.map(({ title, statuses }) =>
        buildAccountingDraftEntriesCountWidget({
          widgetTitle: title,
          filters: dataTableFilters,
          queryArgs: {
            companyId,
            statuses,
          },
        })
      )}
      widgetWidth="full"
    />
  )
}
